import React, { useState } from 'react';

import { ActionIcon, Button, Group, Space, TextInput, Title, useMantineTheme } from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import DrawerPayRateForm from './components/DrawerPayRateForm';
import PayRatesTableContainer from './components/PayRatesTableContainer';

const PayRates = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const payrollPerm = hasPerm('PayrollMutate');
  const [isCreteFormOpened, { open: openCreateForm, close: closeCreateForm }] = useDisclosure(false);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 250);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchTerm(value);
  };
  const handleClearSearchFilter = (): void => {
    setSearchTerm('');
  };

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Pay Rates
          </Title>
          <Group>
            <TextInput
              icon={<IconSearch size={theme.fontSizes.md} />}
              placeholder='Search by name'
              value={searchTerm}
              onChange={handleSearchChange}
              rightSection={
                !!searchTerm ? (
                  <ActionIcon onClick={handleClearSearchFilter} size='md'>
                    <IconX size={theme.fontSizes.md} />
                  </ActionIcon>
                ) : (
                  <Space />
                )
              }
            />
            <Button
              data-cy='openPayRateCreateView'
              leftIcon={<IconPlus size={theme.fontSizes.md} />}
              onClick={openCreateForm}
              disabled={!payrollPerm}
            >
              Pay Rate
            </Button>
          </Group>
        </Group>
      </PageHeader>
      <PayRatesTableContainer searchTerm={debouncedSearchTerm} permission={payrollPerm} />
      <DrawerPayRateForm
        type='create'
        formId='create-pay-rate-form'
        opened={isCreteFormOpened}
        closeHandler={closeCreateForm}
        title={<Title order={3}>Create Pay Rate</Title>}
      />
    </>
  );
};

export default PayRates;
